"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Link = function Link(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M7.04,20 C7.04,22.736 9.264,24.96 12,24.96 L18.4,24.96 L18.4,28 L12,28 C7.584,28 4,24.416 4,20 C4,15.584 7.584,12 12,12 L18.4,12 L18.4,15.04 L12,15.04 C9.264,15.04 7.04,17.264 7.04,20 Z M13.6,21.6 L13.6,18.4 L26.4,18.4 L26.4,21.6 L13.6,21.6 Z M28,12 C32.416,12 36,15.584 36,20 C36,24.416 32.416,28 28,28 L21.6,28 L21.6,24.96 L28,24.96 C30.736,24.96 32.96,22.736 32.96,20 C32.96,17.264 30.736,15.04 28,15.04 L21.6,15.04 L21.6,12 L28,12 Z"
      });
    }
  }));
};
Link.defaultProps = {
  color: null
};
var _default = exports["default"] = Link;
var name = exports.name = 'Link';
var availableProps = exports.availableProps = ['color'];